import store from "@/store";

/**
 * @param {Image} image
 * @param {Boolean} hasCoordinateManualOrder
 *
 * @return {Number}
 */
export default function getImageSortValue(image, hasCoordinateManualOrder) {
  const isManualSortingActiveForImage = store.state.Settings.isManualImagesSortingActive && hasCoordinateManualOrder;
  if (image.isEternal)  {
    return -Infinity
  } else if (image.yearOfBuild && !isManualSortingActiveForImage) {
    return image.yearOfBuild
  } else if (image.epoch) {
    return isManualSortingActiveForImage
      ? ((image.epoch.to + image.epoch.from) / 2) + (image.manualOrder   ? (image.manualOrder   / 10_000) : 0.9999)
      : ((image.epoch.to + image.epoch.from) / 2) + (image.yearOfRebuild ? (image.yearOfRebuild / 10_000) : 1)
  } else if (image.yearOfRebuild && !isManualSortingActiveForImage) {
    return image.yearOfRebuild
  } else {
    return Infinity
  }
}
